const Post = {
  title: "",
  text: "",
  draft: true,
  post_type: "text",
  content_type: "personal",
  content_pillar: null,
  tags: [],
  no_recycle: false,
  /** "tofu" | "mofu" | "bofu" | null */
  funnel_stage: null,
};

export default Post;
